import React from "react";
import "./styles.scss";

const ButtonComponent = ({
  text,
  onClick,
  color,
  shape,
  styles,
  background,
  borderColor,
  disabled,
  className,
  width,
  style,
  type,
  height,
  ...props
}) => {
  return (
    <button
      htmlType={type}
      defaultColor={color}
      shape={shape}
      styles={styles}
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={className + " button-common"}
      style={{
        ...style,
        background: background,
        borderColor: borderColor,
        width: width,
        height: height,
      }}
      {...props}
    >
      <span className="button-text">{text}</span>
    </button>
  );
};
export default ButtonComponent;
